import { render } from "./Dishes.vue?vue&type=template&id=266d5f64&scoped=true"
import script from "./Dishes.vue?vue&type=script&lang=js"
export * from "./Dishes.vue?vue&type=script&lang=js"

import "./Dishes.vue?vue&type=style&index=0&id=266d5f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266d5f64"]])

export default __exports__